import { Css, IconButton, Palette } from "@homebound/beam";
import { openZendesk } from "src/components/ZendeskWidget";
import { useAppNotificationsContext } from "src/contexts/AppNotificationsContext";
import { InboxBell } from "src/routes/inbox/components/InboxBell";
import { GlobalSearchBox } from "src/routes/layout/global-nav/GlobalSearchBox";

export function GlobalNavRightSlot() {
  const { notifications, clear } = useAppNotificationsContext();

  return (
    <div css={Css.df.gap2.$}>
      <GlobalSearchBox />
      <InboxBell />
      {notifications.nonEmpty && <div css={Css.absolute.top(1).left(0.8).bgYellow500.sqPx(5).borderRadius("50%").$} />}
      <IconButton icon="helpCircle" color={Palette.Gray500} inc={3} onClick={() => openZendesk()} />
    </div>
  );
}
